module.exports = __webpack_public_path__ + "img/arrow-pointer-lg-up.41b660f7.svg";